export const put = (key, value) => {
  window.localStorage.setItem(key, value);
};
export const get = key => window.localStorage.getItem(key);
export const remove = key => window.localStorage.removeItem(key);
export const clear = () => {
  window.localStorage.clear();
};

export const safePut = (key, value) => {
  put(key, JSON.stringify(value));
};

export const safeGet = key => {
  try {
    return JSON.parse(get(key));
  } catch (e) {
    console.warn('unable to get for key: ' + key, e);
  }
};
